import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
  styled,
} from '@mui/material';
import { StyledButton } from 'app/components/v2';
import { getPolicyById } from 'app/store/features/privacyPersistedSlice';
import { setChanges } from 'app/store/features/privacyPersistedSlice';
import { Colors, ColorsV2 } from 'app/constants/color';
import apiService from 'app/services/apiService';

const FormContainer = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '20px',
  marginTop: '20px',
});

export default function BoardColumn({ setIsOpen, isOpen }) {
  const { darkmode } = useSelector(state => state.dark);
  const withoutTemplate = useSelector(state => state.privacyPersisted.WithoutTemplate);
  const dispatch = useDispatch();

  const [columnData, setColumnData] = useState({
    name: '',
    describe: '',
  });

  const handleClose = () => {
    setIsOpen({ ...isOpen, addColumn: false });
  };

  const CustomAdornment = styled(InputAdornment)({
    fontFamily: 'DM Sans, sans-serif',
    margin: '0px 5px 0px 0px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '21px',
    color: 'red',
  });

  const handleChange = e => {
    setColumnData({
      ...columnData,
      [e.target.name]: e.target.value,
    });
  };

  const handleClick = async () => {
    try {
      await apiService.createNewDataClassLevel({
        name: columnData.name,
        description: columnData.describe,
      });
      dispatch(setChanges(true));
      dispatch(getPolicyById({ id: withoutTemplate?.policyType, readOnly: true }));
    } catch (error) {
      console.error();
    }
    setIsOpen({ ...isOpen, addColumn: false });
  };

  return (
    <>
      <Dialog open={true} onClose={handleClose}>
        <Box
          sx={{
            background: ColorsV2.secondary,
            width: '600px',
            paddingBottom: '10px',
            minHeight: '25vh',
          }}
        >
          <DialogTitle sx={{ color: ColorsV2.white, textAlign: 'center' }}>
            Add a Column
          </DialogTitle>

          <DialogContent>
            <FormContainer noValidate autoComplete='off'>
              <TextField
                noValidate
                id='name'
                value={columnData?.name}
                name='name'
                onChange={e => handleChange(e)}
                InputProps={{
                  startAdornment: (
                    <CustomAdornment position='start'>
                      <Typography
                        sx={{
                          color: ColorsV2.white,
                          fontFamily: 'DM Sans, sans-serif',
                          fontSize: '14px',
                        }}
                      >
                        Name:
                      </Typography>
                    </CustomAdornment>
                  ),
                  style: {
                    color: ColorsV2.white,
                    fontFamily: 'DM Sans, sans-serif',
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '21px',
                    borderRadius: '8px',
                    height: '48px',
                  },
                }}
                InputLabelProps={{
                  style: {
                    color: 'inherit',
                  },
                }}
                sx={{
                  width: '100%',
                  backgroundColor: 'transparent',

                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: ColorsV2.outline,
                    borderRadius: '0px',
                  },
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: ColorsV2.outline,
                    },
                  },

                  marginRight: '10px',
                  '& label.Mui-focused': {
                    color: ColorsV2.white,
                    transform: 'translate(15px, -16px)',
                    fontSize: '0.75rem',
                  },
                  '&  .MuiFormHelperText-root.Mui-error': {
                    background: ColorsV2.secondary,
                    color: '#FF2800',
                    width: '101%',
                    height: '100%',
                    fontSize: '1rem',
                    marginTop: '-0.5%',
                    marginLeft: -0.15,
                  },
                }}
              />
              <TextField
                noValidate
                id='name'
                value={columnData?.describe}
                name='describe'
                onChange={e => handleChange(e)}
                InputProps={{
                  startAdornment: (
                    <CustomAdornment position='start'>
                      <Typography
                        sx={{
                          color: ColorsV2.white,
                          fontFamily: 'DM Sans, sans-serif',
                          fontSize: '14px',
                        }}
                      >
                        Description:
                      </Typography>
                    </CustomAdornment>
                  ),
                  style: {
                    color: ColorsV2.white,
                    fontFamily: 'DM Sans, sans-serif',
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '21px',
                    borderRadius: '8px',
                    height: '48px',
                  },
                }}
                InputLabelProps={{
                  style: {
                    color: 'inherit',
                  },
                }}
                sx={{
                  width: '100%',
                  backgroundColor: 'transparent',

                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: ColorsV2.outline,
                    borderRadius: '0px',
                  },
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: ColorsV2.outline,
                    },
                  },

                  marginRight: '10px',
                  '& label.Mui-focused': {
                    color: darkmode ? Colors.primary : 'inherit',
                    transform: 'translate(15px, -16px)',
                    fontSize: '0.75rem',
                  },
                  '&  .MuiFormHelperText-root.Mui-error': {
                    background: darkmode ? '#202c47' : 'white',
                    color: '#FF2800',
                    width: '101%',
                    height: '100%',
                    fontSize: '1rem',
                    marginTop: '-0.5%',
                    marginLeft: -0.15,
                  },
                }}
              />

              <StyledButton name='IconButton' onClick={handleClick}>
                Add New Column
              </StyledButton>
            </FormContainer>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
}
